import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
.scheduler-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #111827;
  padding: 32px;
}

.workspace-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 520px);
  gap: 24px;
  align-items: end;
  margin: 0 auto 24px;
  max-width: 1480px;
}

.title-block .eyebrow {
  margin: 0 0 10px;
  color: #0f766e;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}
.title-block h1 {
  margin: 0;
  color: #0f172a;
  font-size: 38px;
  font-weight: 850;
  line-height: 1.14;
  letter-spacing: 0;
}
.title-block .summary {
  max-width: 760px;
  margin: 14px 0 0;
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
}

.top-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}
.nav-link:hover {
  border-color: #0f766e;
  background: #f0fdfa;
  color: #0f766e;
}

.control-panel {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.8fr;
  gap: 10px;
  align-items: end;
  padding: 16px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.control-field {
  display: grid;
  gap: 6px;
}
.control-field span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}
.control-field select,
.control-field input {
  width: 100%;
  height: 42px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  font-weight: 650;
  outline: none;
  padding: 0 12px;
}
.control-field select:focus,
.control-field input:focus {
  border-color: #0f766e;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.14);
}

.action-row {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: 1fr 112px;
  gap: 10px;
}

button {
  border: 0;
  font-family: inherit;
}

.btn-primary,
.btn-secondary,
.link-button,
.legend-item,
.method-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 800;
  transition: transform 120ms ease, box-shadow 120ms ease, background 120ms ease;
}
.btn-primary:disabled,
.btn-secondary:disabled,
.link-button:disabled,
.legend-item:disabled,
.method-row:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.btn-primary {
  background: #0f766e;
  color: #ffffff;
  box-shadow: 0 10px 18px rgba(15, 118, 110, 0.2);
}
.btn-primary:not(:disabled):hover {
  background: #115e59;
  transform: translateY(-1px);
}

.btn-secondary {
  background: #111827;
  color: #ffffff;
}
.btn-secondary:not(:disabled):hover {
  background: #273449;
  transform: translateY(-1px);
}

.error-banner,
.data-notice {
  max-width: 1480px;
  margin: 0 auto 18px;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
}

.error-banner {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
  font-weight: 750;
}

.data-notice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #9a3412;
}
.data-notice i {
  margin-top: 3px;
  color: #ea580c;
}
.data-notice div {
  display: grid;
  gap: 3px;
}
.data-notice strong {
  color: #7c2d12;
  font-weight: 900;
}
.data-notice span {
  line-height: 1.5;
  font-weight: 700;
}

.model-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-width: 1480px;
  margin: 0 auto 18px;
}

.model-node {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 58px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px 12px;
  color: #334155;
  font-size: 13px;
  font-weight: 750;
}
.model-node .index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-weight: 900;
}

.metric-grid,
.experiment-overview,
.experiment-grid,
.experiment-table-grid,
.analysis-grid,
.detail-grid,
.methodology-grid {
  display: grid;
  gap: 16px;
  max-width: 1480px;
  margin: 0 auto 18px;
}

.metric-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.experiment-overview {
  gap: 12px;
}

.experiment-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}
.experiment-card-grid .metric-card strong {
  font-size: 21px;
  overflow-wrap: anywhere;
}

.experiment-grid {
  grid-template-columns: minmax(0, 1.22fr) minmax(320px, 0.78fr);
}

.experiment-table-grid {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
}

.metric-card,
.methods-panel,
.chart-panel,
.experiment-chart-panel,
.training-panel,
.design-panel,
.table-panel,
.demo-method-panel,
.grouping-panel,
.reference-panel {
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.metric-card {
  min-height: 128px;
  padding: 18px;
}
.metric-card .label {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
  text-transform: uppercase;
}
.metric-card strong {
  display: block;
  margin-top: 14px;
  color: #0f172a;
  font-size: 25px;
  line-height: 1.18;
  letter-spacing: 0;
}
.metric-card small {
  display: block;
  margin-top: 8px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.analysis-grid {
  grid-template-columns: 0.88fr 1.12fr;
}

.methods-panel,
.chart-panel,
.experiment-chart-panel,
.training-panel,
.design-panel,
.table-panel,
.demo-method-panel,
.grouping-panel,
.reference-panel {
  padding: 18px;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.panel-head h2 {
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
  letter-spacing: 0;
}
.panel-head span {
  color: #64748b;
  font-size: 13px;
  font-weight: 750;
}

.chart-control-head {
  align-items: end;
}

.metric-select {
  display: grid;
  gap: 6px;
  min-width: 180px;
}
.metric-select span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
}
.metric-select select {
  height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 800;
  outline: none;
}

.method-row {
  width: 100%;
  min-height: 72px;
  justify-content: stretch;
  display: grid;
  grid-template-columns: minmax(170px, 1fr) minmax(120px, 220px) 72px;
  gap: 14px;
  align-items: center;
  background: #f8fafc;
  color: #1f2937;
  margin-top: 10px;
  padding: 12px;
  text-align: left;
}
.method-row.active {
  background: #ecfdf5;
  box-shadow: inset 0 0 0 2px #10b981;
}
.method-row:hover {
  background: #eef6ff;
}
.method-row b {
  text-align: right;
  color: #0f172a;
  font-size: 18px;
}

.method-copy {
  display: grid;
  gap: 4px;
}
.method-copy strong {
  color: #111827;
  font-size: 15px;
  font-weight: 850;
}
.method-copy span {
  color: #64748b;
  font-size: 12px;
  font-weight: 750;
}

.score-bar {
  height: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}
.score-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.chart-box {
  height: 286px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 14px;
}
.chart-box svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.chart-box line {
  stroke: #e2e8f0;
  stroke-width: 0.6;
}
.chart-box polyline {
  fill: none;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cumulative-chart-box,
.training-chart-box {
  height: 284px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 14px;
}
.cumulative-chart-box svg,
.training-chart-box svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.cumulative-chart-box line,
.training-chart-box line {
  stroke: #e2e8f0;
  stroke-width: 0.6;
}
.cumulative-chart-box polyline,
.training-chart-box polyline {
  fill: none;
  stroke-width: 2.1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.training-chart-box {
  height: 190px;
}

.source-ticks {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-top: 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 850;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.legend-item {
  min-height: 34px;
  border: 1px solid #dbe3ef;
  background: #ffffff;
  color: #334155;
  padding: 0 10px;
}
.legend-item.active {
  border-color: #0f766e;
  background: #f0fdfa;
}
.legend-item i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.experiment-legend {
  max-height: 112px;
  overflow: auto;
}

.legend-item-static {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 800;
}
.legend-item-static i {
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border-radius: 50%;
}

.training-list {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}
.training-list article {
  display: grid;
  gap: 5px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}
.training-list strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
}
.training-list span {
  color: #475569;
  font-size: 12px;
  font-weight: 750;
}
.training-list code {
  color: #64748b;
  font-size: 11px;
  white-space: normal;
  overflow-wrap: anywhere;
}

.detail-grid {
  grid-template-columns: 0.82fr 1.18fr;
}

.methodology-grid {
  grid-template-columns: 1.2fr 0.8fr;
}

.grouping-panel {
  grid-column: 1/-1;
}

.design-panel h2 {
  margin: 0 0 14px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
}
.design-panel dl {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 12px 16px;
  margin: 0;
}
.design-panel dt {
  color: #475569;
  font-size: 13px;
  font-weight: 850;
}
.design-panel dd {
  margin: 0;
  color: #111827;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.link-button {
  min-height: 34px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  padding: 0 10px;
}
.link-button:hover {
  background: #f8fafc;
}

.table-wrap {
  max-height: 360px;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.table-wrap.compact {
  max-height: 420px;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
}
table th,
table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 12px;
  text-align: right;
  white-space: nowrap;
  font-size: 13px;
}
table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  color: #475569;
  font-weight: 850;
}
table td {
  color: #1f2937;
  font-weight: 650;
}
table td strong,
table td small {
  display: block;
}
table td strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
}
table td small {
  margin-top: 3px;
  color: #64748b;
  font-size: 11px;
  font-weight: 650;
  white-space: normal;
  line-height: 1.35;
}
table th:first-child,
table td:first-child {
  text-align: left;
}

.method-card-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.data-method {
  display: grid;
  gap: 8px;
  align-content: start;
  min-height: 176px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
}
.data-method strong {
  color: #0f172a;
  font-size: 16px;
  font-weight: 900;
}
.data-method code {
  display: block;
  border-radius: 6px;
  background: #111827;
  color: #e0f2fe;
  padding: 8px;
  font-size: 12px;
  line-height: 1.45;
  white-space: normal;
  overflow-wrap: anywhere;
}
.data-method span,
.data-method small {
  color: #475569;
  line-height: 1.5;
}
.data-method span {
  font-size: 13px;
  font-weight: 750;
}
.data-method small {
  font-size: 12px;
  font-weight: 650;
}

.step-list {
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding-left: 22px;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.main-grouping-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
.main-grouping-list article {
  display: grid;
  gap: 7px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}
.main-grouping-list strong {
  color: #0f766e;
  font-size: 13px;
  font-weight: 900;
}
.main-grouping-list span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.direction-note {
  margin: 12px 0 0;
  border-left: 4px solid #0f766e;
  background: #ecfdf5;
  color: #134e4a;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.55;
}

.reference-panel {
  display: grid;
  align-content: start;
}

.reference-link {
  display: grid;
  gap: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  margin-top: 10px;
  padding: 12px;
  text-decoration: none;
}
.reference-link:hover {
  border-color: #0f766e;
  background: #f0fdfa;
}
.reference-link strong {
  font-size: 14px;
  font-weight: 900;
}
.reference-link span {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

@media (max-width: 1180px) {
  .workspace-head,
  .experiment-grid,
  .experiment-table-grid,
  .analysis-grid,
  .detail-grid,
  .methodology-grid {
    grid-template-columns: 1fr;
  }
  .model-strip,
  .experiment-card-grid,
  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .method-card-list {
    grid-template-columns: 1fr;
  }
  .main-grouping-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .scheduler-page {
    padding: 18px;
  }
  .title-block h1 {
    font-size: 30px;
  }
  .control-panel,
  .model-strip,
  .experiment-card-grid,
  .metric-grid,
  .main-grouping-list {
    grid-template-columns: 1fr;
  }
  .chart-control-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .metric-select {
    width: 100%;
  }
  .method-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .method-row b {
    text-align: left;
  }
  .design-panel dl {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageMainComponent implements OnInit {
    public metadata: any = null;
    public result: any = null;
    public experiment: any = null;
    public scenario: string = "mixed";
    public steps: number = 160;
    public seed: number = 42;
    public loading: boolean = false;
    public error: string = "";
    public selectedMethod: string = "proposed_ppo";
    public selectedExperimentMetric: string = "score";

    public previewColumns: Array<{ key: string, label: string, type?: string }> = [
        { key: "method_label", label: "Method" },
        { key: "timestep", label: "Step" },
        { key: "score", label: "Score" },
        { key: "reward", label: "Reward" },
        { key: "latency_urllc", label: "URLLC ms" },
        { key: "drop_rate_mmtc", label: "mMTC Drop", type: "rate" },
        { key: "sla_violation_count", label: "SLA" },
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.load();
        await this.loadExperiments();
        await this.runDemo();
    }

    public async load(): Promise<void> {
        const response: any = await wiz.call("load");
        if (response && response.code === 200) {
            this.metadata = response.data;
        }
        await this.service.render();
    }

    public async loadExperiments(): Promise<void> {
        const response: any = await wiz.call("experiments");
        if (response && response.code === 200) {
            this.experiment = response.data;
        }
        await this.service.render();
    }

    public async runDemo(): Promise<void> {
        this.loading = true;
        this.error = "";
        await this.service.render();

        try {
            const response: any = await wiz.call("run", {
                scenario: this.scenario,
                steps: this.steps,
                seed: this.seed,
            });

            if (!response || response.code !== 200) {
                throw new Error("Simulation request failed");
            }

            this.result = response.data;
            if (this.result && this.result.winner) {
                this.selectedMethod = this.result.winner.method;
            }
        } catch (error: any) {
            this.error = error && error.message ? error.message : String(error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public downloadCsv(): void {
        const params = new URLSearchParams({
            scenario: this.scenario,
            steps: String(this.steps),
            seed: String(this.seed),
        });
        window.open(`${wiz.url("csv")}?${params.toString()}`, "_blank");
    }

    public selectMethod(method: string): void {
        this.selectedMethod = method;
    }

    public scenarioOptions(): any[] {
        if (!this.metadata || !this.metadata.scenario_options) return [];
        return this.metadata.scenario_options;
    }

    public methodSummaries(): any[] {
        if (!this.result || !this.result.summaries) return [];
        return this.result.summaries;
    }

    public previewRows(): any[] {
        if (!this.result || !this.result.preview_rows) return [];
        return this.result.preview_rows.slice().reverse();
    }

    public scoreSeries(): any[] {
        if (!this.result || !this.result.score_series) return [];
        return this.result.score_series;
    }

    public experimentSources(): any[] {
        if (!this.experiment || !this.experiment.sources) return [];
        return this.experiment.sources;
    }

    public experimentSeries(): any[] {
        if (!this.experiment || !this.experiment.series) return [];
        return this.experiment.series;
    }

    public experimentMethods(): any[] {
        if (!this.experiment || !this.experiment.method_rows) return [];
        return this.experiment.method_rows.slice(0, 12);
    }

    public experimentMetrics(): any[] {
        if (!this.experiment || !this.experiment.metrics) return [];
        return this.experiment.metrics;
    }

    public selectedExperimentMetricInfo(): any {
        const metrics = this.experimentMetrics();
        return metrics.find((metric: any) => metric.key === this.selectedExperimentMetric) || metrics[0] || null;
    }

    public experimentPoints(series: any): string {
        const metric = this.selectedExperimentMetricInfo();
        if (!series || !series.points || !metric || !this.experiment) return "";
        const range = this.experiment.metric_ranges ? this.experiment.metric_ranges[metric.key] : null;
        if (!range) return "";
        const maxIndex = Math.max(this.experimentSources().length - 1, 1);
        const span = Math.max(Number(range.max) - Number(range.min), 0.000001);
        return series.points
            .filter((point: any) => point[metric.key] !== null && point[metric.key] !== undefined)
            .map((point: any) => {
                const x = Math.max(0, Math.min(100, (Number(point.source_index) / maxIndex) * 100));
                const normalized = Math.max(0, Math.min(1, (Number(point[metric.key]) - Number(range.min)) / span));
                const y = metric.lower_is_better ? normalized * 100 : 100 - (normalized * 100);
                return `${x},${y}`;
            }).join(" ");
    }

    public trainingPoints(history: any): string {
        if (!history || !history.points || history.points.length === 0) return "";
        const histories = this.trainingHistories();
        const allPoints = histories.flatMap((item: any) => item.points || []);
        const maxIteration = Math.max(...allPoints.map((point: any) => Number(point.iteration)), 1);
        const scores = allPoints.map((point: any) => Number(point.score)).filter((value: number) => !Number.isNaN(value));
        const low = Math.min(...scores);
        const high = Math.max(...scores);
        const span = Math.max(high - low, 0.000001);
        return history.points.map((point: any) => {
            const x = Math.max(0, Math.min(100, (Number(point.iteration) / maxIteration) * 100));
            const y = 100 - (Math.max(0, Math.min(1, (Number(point.score) - low) / span)) * 100);
            return `${x},${y}`;
        }).join(" ");
    }

    public trainingHistories(): any[] {
        if (!this.experiment || !this.experiment.training_histories) return [];
        return this.experiment.training_histories;
    }

    public selectedSummary(): any {
        const summaries = this.methodSummaries();
        return summaries.find((summary: any) => summary.method === this.selectedMethod) || summaries[0] || null;
    }

    public scorePoints(series: any): string {
        if (!series || !series.points || series.points.length === 0) return "";
        const maxX = Math.max(Number(this.result ? this.result.steps : this.steps), 1);
        return series.points.map((point: any) => {
            const x = Math.max(0, Math.min(100, (Number(point.x) / maxX) * 100));
            const y = Math.max(0, Math.min(100, 100 - Number(point.y)));
            return `${x},${y}`;
        }).join(" ");
    }

    public colorFor(method: string): string {
        const colors: any = {
            fixed: "#64748b",
            round_robin: "#d97706",
            greedy: "#0891b2",
            basic_ppo: "#7c3aed",
            proposed_ppo: "#059669",
            neural_proposed_ppo: "#16a34a",
            lyapunov_regularized_proposed_ppo: "#0d9488",
            trained_ppo: "#2563eb",
            neural_ppo: "#dc2626",
            slice_grpo: "#9333ea",
            teacher_slice_grpo: "#a855f7",
            adaptive_slice_grpo: "#0f766e",
            max_weight: "#1f2937",
            mpc_proxy: "#ea580c",
            dqn_proxy: "#0284c7",
        };
        return colors[method] || "#111827";
    }

    public barWidth(value: any, max: number): string {
        const numberValue = Number(value || 0);
        const width = Math.max(2, Math.min(100, (numberValue / max) * 100));
        return `${width}%`;
    }

    public format(value: any, digits: number = 2): string {
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return "-";
        return numberValue.toLocaleString("ko-KR", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    public formatInteger(value: any): string {
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return "-";
        return numberValue.toLocaleString("ko-KR", {
            maximumFractionDigits: 0,
        });
    }

    public formatExperimentValue(value: any, metricKey: string): string {
        if (metricKey === "drop_rate") return this.formatRate(value);
        if (metricKey === "sla_violations") return this.format(value, 1);
        const metric = this.experimentMetrics().find((item: any) => item.key === metricKey);
        return this.format(value, metric ? metric.digits : 2);
    }

    public formatCell(row: any, column: any): string {
        if (!row || !column) return "-";
        if (column.type === "rate") return this.formatRate(row[column.key]);
        if (column.key === "timestep" || column.key === "sla_violation_count") return this.formatInteger(row[column.key]);
        if (column.key === "method_label") return row[column.key] || "-";
        return this.format(row[column.key], 2);
    }

    public formatRate(value: any): string {
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return "-";
        return `${(numberValue * 100).toFixed(2)}%`;
    }
}

export default PageMainComponent;